import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-32d122d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "containers" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "header-text" }, "Grandilo Blogs", -1))
const _hoisted_3 = { class: "post" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "post-text" }
const _hoisted_6 = { class: "story" }
const _hoisted_7 = { class: "date" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Navbar),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blogs, (blog, id) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "each-post",
            key: id
          }, [
            _createElementVNode("img", {
              src: blog.displayURL,
              class: "img",
              alt: "post-image"
            }, null, 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h3", null, _toDisplayString(blog.title.length > 45
                  ? blog.title.slice(0, 45) + "..."
                  : blog.title), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.extractPlainText(blog.body)), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", null, _toDisplayString(Math.ceil(blog.body.split(" ").length / 250)) + " min read ", 1),
                _createElementVNode("p", null, _toDisplayString(new Date(blog.createdAt.seconds * 1000).toDateString()), 1)
              ]),
              _createElementVNode("button", {
                class: "link",
                onClick: ($event: any) => (_ctx.details(blog.id))
              }, " Continue reading ", 8, _hoisted_8)
            ])
          ]))
        }), 128))
      ])
    ]),
    _hoisted_9,
    _createVNode(_component_Footer)
  ]))
}